// extracted by mini-css-extract-plugin
export default {"container":"HoanPhiDaTao_container__dlrWd"};